import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { setOwner } from '../../actions/spaces/SetOwnerAction';
import { ContentDetailSection } from './ContentDetailSection';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { MapDispatchToProps } from '../../utils/ConnectUtils';
import { ACTION_DIALOG_TESTID } from './ContentDetailsDialog';

interface OwnerDetailSectionOwnProps {
  readonly content: IContentInfo<ExplorableItemType>;
  readonly isActionEnabled: boolean;
}

interface OwnerDetailDispatchProps {
  readonly setOwner: (items: IContentInfo<ExplorableItemType>[]) => void;
}

export type OwnerDetailSectionProps = OwnerDetailSectionOwnProps & OwnerDetailDispatchProps;

export function OwnerDetailSection(props: OwnerDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.owner()}
      detail={props.content.owner ? props.content.owner.displayName : ''}
      action={props.isActionEnabled &&
        <ButtonWidget
          buttonType={ButtonType.Outline}
          children={Messages.changeOwner()}
          testId={`${ACTION_DIALOG_TESTID}-set-owner-action`}
          handleClick={() => {
            props.setOwner([props.content]);
          }}
        />
      }
    />
  );
}

const mapDispatchToProps: MapDispatchToProps<OwnerDetailDispatchProps> = (dispatch) => bindActionCreators({
  setOwner: setOwner,
}, dispatch);

export const ConnectedOwnerDetailSection: React.ComponentClass<OwnerDetailSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(OwnerDetailSection);
